import { render, staticRenderFns } from "./DragOptionsDialog.vue?vue&type=template&id=54b47608"
import script from "./DragOptionsDialog.vue?vue&type=script&lang=js"
export * from "./DragOptionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports